import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './user/login/Login1';
import ConfirmEmail from './confirmation/ConfirmEmail1';
import ConfirmPayment from './confirmation/ConfirmPayment';
import Resetpassword from './confirmation/resetpassword';
import LoginHome from './user/counters/LoginHome1';
import Signup from './user/signup/Signup1';
import Profile from './user/profile/Profile1';
import Amount from './user/amount/Amount2';
import AppHeader from './common/AppHeader1';
import AppFooter from './common/AppFooter';
import EventBus from './common/EventBus';
import NotFound from './common/NotFound';
import Welcome from './common/Welcome';
import Rules from './common/Rules';
import EmailSend from './common/EmailSend'
import { ACCESS_TOKEN, EXPIRATION, REFRESH_TOKEN, DEVICE_ID } from './constants';
import { getCurrentUser, setCountVal, logout } from './util/axios_utils';
import { Route, useNavigate, Routes } from 'react-router-dom';
import { notification } from 'antd';
import Tokenexpired from './errorpages/tokenexpired';
import Forgotpassword from './user/forgotpassword/forgotpassword1';
import Addtoken from './user/addtoken/Addtoken1';
import Warning from './common/Warning';
import LoadingIndicator from './common/LoadingIndicator';



const App = () => {
  let navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [underConstruction, setUnderConstruction] = useState(false);
  useEffect(() => {
    const handleUnaccesible = () => {
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      localStorage.removeItem(EXPIRATION);
      setCurrentUser(null);
      setIsAuthenticated(false);
      // navigate(redirectTo);
    }
    notification.config({
      placement: 'topRight',
      top: 70,
      duration: 3,
    });
    setIsLoading(true);
    setUnderConstruction(false);
    getCurrentUser()
      .then(response => {

        setCurrentUser(response);
        setIsAuthenticated(true);
        setIsLoading(false);

      }).catch(error => {
        setIsAuthenticated(false);
        setIsLoading(false);
      });
    EventBus.on("handleLogout", () => {
      handleUnaccesible();
    });

    EventBus.on("handleWritevalue", (e) => {
      handleWritevalue(e);
    });

    return () => {

      EventBus.remove("handleLogout");
      EventBus.remove("handleWritevalue");
    }
 
  }, []);

  const handleLogout = (redirectTo = "/login", notificationType = "success", description = "Вы  вышли из личного кабинета.") => {
    const DeviceInfo = {
      deviceId: localStorage.getItem(DEVICE_ID),
      deviceType: "DEVICE_TYPE_ANDROID",
      notificationToken: "N1"
    }
    const logoutrequest = {
      deviceInfo: DeviceInfo
    }
    setIsLoading(true);
    logout(logoutrequest)
      .then(response => {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(REFRESH_TOKEN);
        localStorage.removeItem(EXPIRATION);
        localStorage.removeItem(DEVICE_ID);
        setCurrentUser(null);
        setIsAuthenticated(false);
        setIsLoading(false);
        navigate(redirectTo);
        notification[notificationType]({
          message: 'Портал ЖКХ',
          description: description,
        });
      }).catch(error => {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(REFRESH_TOKEN);
        localStorage.removeItem(EXPIRATION);
        localStorage.removeItem(DEVICE_ID);
        setCurrentUser(null);
        setIsAuthenticated(false);
        setIsLoading(false);
        navigate(redirectTo);
        notification[notificationType]({
          message: 'Портал ЖКХ',
          description: description,
        });
      });


  }


  const handleLogin = (redirectTo = "/welcome") => {
    setIsAuthenticated(false);
    setIsLoading(true);
    getCurrentUser()
      .then(response => {
        setCurrentUser(response);
        setIsAuthenticated(true);
        setIsLoading(false);

      }).catch(error => {
        setIsAuthenticated(false);
        setIsLoading(false);
      });
    navigate(redirectTo);
  }

  const handleMenu = (e) => {
    if (e.key === 'logout') {
      handleLogout();
    } else {
      navigate(e.key);
    }
  }


  const handleWritevalue = (request) => {
    // console.log('APP HTTP request:  ', request);
    setCountVal(request)
      .then(response => {

        notification.success({
          message: 'Портал ЖКХ',
          description: "Ваши показания успешно зарегистрированы в системе."
        });
      }).catch(error => {
        if (error.status === 404) {
          notification.error({
            message: 'Портал ЖКХ',
            description: 'Извините, что-то пошло не так. Попробуйте еще раз!'
          });
        } else if (error.status === 406) {
          EventBus.dispatch("handleLogout");
        } else {
          notification.error({
            message: 'Портал ЖКХ',
            description: 'Извините, что-то пошло не так. Попробуйте еще раз!'
          });
        }
      });
  }
  if (isLoading) {
    return <div className="app-container">
      <AppHeader isAuthenticated={isAuthenticated}
        currentUser={currentUser}
        onLogout={handleLogout}
        onClick={handleMenu} />
      <div className="container">
        <LoadingIndicator />
      </div>
      <AppFooter isAuthenticated={isAuthenticated} />
    </div>
  };
  return (
    <div className="app-container">
      <AppHeader isAuthenticated={isAuthenticated}
        currentUser={currentUser}
        onLogout={handleLogout}
        onClick={handleMenu}
        isLoading={isLoading} />
      <div className="container">
        <Routes>
          <Route path="/" element={isAuthenticated ? (<Welcome isAuthenticated={isAuthenticated} currentUser={currentUser} />) : (<Login onLogin={handleLogin} isLoading={isLoading} underConstruction={underConstruction}/>)} />
          <Route path="/counters" element={isAuthenticated ? (<LoginHome isAuthenticated={isAuthenticated} currentUser={currentUser} />) : (<Login onLogin={handleLogin} underConstruction={underConstruction}/>)} />
          <Route path="/amount" element={isAuthenticated ? (<Amount isAuthenticated={isAuthenticated} currentUser={currentUser} />) : (<Login onLogin={handleLogin} underConstruction={underConstruction}/>)} />
          <Route path="/login" element={isAuthenticated ? (<Welcome isAuthenticated={isAuthenticated} currentUser={currentUser} />) : (<Login onLogin={handleLogin} underConstruction={underConstruction}/>)} />
          <Route path="/signup" element={isAuthenticated ? (<Welcome isAuthenticated={isAuthenticated} currentUser={currentUser} />) : (<Signup underConstruction={underConstruction}/>)} />
          <Route path="/users" element={isAuthenticated ? (<Profile isAuthenticated={isAuthenticated} currentUser={currentUser} />) : (<Login onLogin={handleLogin} underConstruction={underConstruction}/>)} />
          <Route path="/addtoken" element={isAuthenticated ? (<Addtoken isAuthenticated={isAuthenticated} currentUser={currentUser} />) : (<Login onLogin={handleLogin} underConstruction={underConstruction}/>)} />
          <Route path="/expired" element={<Tokenexpired />} />
          <Route path="/forgotpassword" element={<Forgotpassword />} />
          <Route path="/confirmemail" element={<ConfirmEmail />} />
          <Route path="/resetpassword" element={<Resetpassword />} />
          <Route path="/confirmpayment" element={<ConfirmPayment isAuthenticated={isAuthenticated} />} />
          <Route path="/welcome" element={isAuthenticated ? (<Welcome isAuthenticated={isAuthenticated} currentUser={currentUser} />) : (<Login onLogin={handleLogin} isLoading={isLoading} />)} />
          <Route path="/warning" element={<Warning />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/emailsend" element={isAuthenticated ? (<Welcome isAuthenticated={isAuthenticated} currentUser={currentUser} />) : (<EmailSend />)} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <AppFooter isAuthenticated={isAuthenticated} />
    </div>
  );

}

export default App;
